module.exports = __webpack_public_path__ + "img/img44.f55049a1.png";